const sanitizeUrl = (value) => (value ? value.replace(/\/+$/, "") : "");

const apiEnv = (process.env.REACT_APP_API_ENV || "staging").toLowerCase();

const explicitBase = sanitizeUrl(process.env.REACT_APP_API_BASE_URL);
const productionBase = sanitizeUrl(process.env.REACT_APP_API_BASE_URL_PRODUCTION);
const stagingBase = sanitizeUrl(process.env.REACT_APP_API_BASE_URL_STAGING);

const fallbackByEnv = {
  production: productionBase || "https://conexaodetranpr.sindilocpr.com.br/api",
  staging: stagingBase || "https://api-staging.sindilocpr.com.br/api",
};

const URL_BASE = explicitBase || fallbackByEnv[apiEnv] || fallbackByEnv.staging;

if (!explicitBase && process.env.NODE_ENV !== "production") {
  // Surface a helpful warning only in dev builds.
  // eslint-disable-next-line no-console
  console.warn(
    "[API] REACT_APP_API_BASE_URL não definido, usando fallback:",
    URL_BASE,
  );
}

export { URL_BASE };
